import React, { Component } from "react";

import { Row, Col } from "antd";
import { Margin } from "styled-components-spacing";
import Center from "react-center";
import LazyLoad from "react-lazyload";
import { DownloadOutlined } from "@ant-design/icons";

// CSS Files
import "../../Fonts/Fonts.css";
import "../../Statics/Common/FontStyle.css";
import "../../Statics/HomePage/DownloadApp.css";
import appMockup from "../../Imgs/HomePage/app.jpg";

const DownloadApps = (props) => {
  return props.size === "laptopdesktop" ? (
    <div style={{ backgroundColor: "#fff", marginBottom: "5%" }}>
      <Center>
        <Margin top={4}>
          <p className="subTitle">
            <strong>دانلود اپلیکیشن</strong>
          </p>
        </Margin>
      </Center>
      <Center>
        <div className="subTitleHR"></div>
      </Center>
      <Margin top={3}></Margin>
      <Row>
        <Col span={3}></Col>
        <Col span={18}>
          <div className="download-app">
            <div className="download-app-left-side">
              <h4
                style={{
                  fontFamily: "IRANSans",
                  color: "#ed1c24",
                  direction: "rtl",
                  textAlign: "center",
                  marginBottom: "10%",
                }}
              >
                <strong>دانلود اپلیکیشن‌های ایرانیان پوشش</strong>
              </h4>

              <p className="app-textParagraph">
                به منظور استفاده از خدمات جامع شرکت ایرانیان پوشش در حوزه‌های
                اعلام خسارت  می‌توانید اپلیکیشن سپر را
                دانلود نمایید.
              </p>
              <Margin top={1}>
                <a
                  href="/download-app-sanaap"
                  class="introBtn introBtn-white introBtn-animated"
                  style={{ fontSize: ".8em", fontFamily: "IRANSans" }}
                >
                  <DownloadOutlined style={{ color: "#fff" }} /> دانلود اپلیکیشن
                  سپر
                </a>
              </Margin>
              <Margin top={4}>
                <p className="app-textParagraph">
                  جهت دانلود اپ‌های کارشناس شرکت ایرانیان پوشش از طریق لینک زیر
                  اقدام نمایید.
                </p>
              </Margin>
              <Margin top={1}>
                <a
                  href="/download-app-arzyab"
                  class="introBtn introBtn-white introBtn-animated"
                  style={{ fontSize: ".8em", fontFamily: "IRANSans" , marginLeft:"1%" }}
                >
                  <DownloadOutlined style={{ color: "#fff" }} /> دانلود اپلیکیشن
                  کارشناس اتومبیل
                </a>
                <a
                  href="/download-app-arzyab-amval"
                  class="introBtn introBtn-white introBtn-animated"
                  style={{ fontSize: ".8em", fontFamily: "IRANSans" , marginRight:"1%" }}
                >
                  <DownloadOutlined style={{ color: "#fff" }} /> دانلود اپلیکیشن
                  کارشناس اموال
                </a>
              </Margin>
            </div>

            <div className="download-app-right-side">
              <img className="app-mockup" src={appMockup} />
            </div>
          </div>
        </Col>
        <Col span={3}></Col>
      </Row>
    </div>
  ) : props.size === "tablet" ? (
    <div style={{ backgroundColor: "#fff", marginBottom: "5%" }}>
      <Center>
        <Margin top={4}>
          <p className="subTitleTablet">
            <strong>دانلود اپلیکیشن</strong>
          </p>
        </Margin>
      </Center>
      <Center>
        <div className="subTitleHR"></div>
      </Center>
      <Margin top={3}></Margin>
      <Row>
        <Col span={3}></Col>
        <Col span={18}>
          <div className="download-app">
            <div className="download-app-left-side">
              <h4
                style={{
                  fontFamily: "IRANSans",
                  color: "#ed1c24",
                  direction: "rtl",
                  textAlign: "center",
                  marginBottom: "10%",
                  fontSize: "1.05em",
                }}
              >
                <strong>دانلود اپلیکیشن‌های ایرانیان پوشش</strong>
              </h4>

              <p className="app-textParagraphTablet">
                به منظور استفاده از خدمات جامع شرکت ایرانیان پوشش در حوزه‌های
                اعلام خسارت  می‌توانید اپلیکیشن سپر را
                دانلود نمایید.
              </p>
              <Margin top={1}>
                <a
                  href="/download-app-sanaap"
                  class="introBtn introBtn-white introBtn-animated"
                  style={{ fontSize: ".8em", fontFamily: "IRANSans" }}
                >
                  <DownloadOutlined style={{ color: "#fff" }} /> دانلود اپلیکیشن
                  سپر
                </a>
              </Margin>
              <Margin top={4}>
                <p className="app-textParagraphTablet">
                  جهت دانلود اپ‌های کارشناس شرکت ایرانیان پوشش از طریق لینک زیر
                  اقدام نمایید.
                </p>
              </Margin>
              <Margin top={1}>
                <a
                  href="/download-app-arzyab"
                  class="introBtn introBtn-white introBtn-animated"
                  style={{ fontSize: ".8em", fontFamily: "IRANSans" , marginLeft:"1%" }}
                >
                  <DownloadOutlined style={{ color: "#fff" }} /> دانلود اپلیکیشن
                  کارشناس اتومبیل
                </a>
                <a
                  href="/download-app-arzyab-amval"
                  class="introBtn introBtn-white introBtn-animated"
                  style={{ fontSize: ".8em", fontFamily: "IRANSans" , marginRight:"1%" }}
                >
                  <DownloadOutlined style={{ color: "#fff" }} /> دانلود اپلیکیشن
                  کارشناس اموال
                </a>
              </Margin>
            </div>

            <div className="download-app-right-side">
              <img className="app-mockup" src={appMockup} />
            </div>
          </div>
        </Col>
        <Col span={3}></Col>
      </Row>
    </div>
  ) : (
    <div style={{ backgroundColor: "#fff", marginBottom: "5%" }}>
      <Center>
        <Margin top={4}>
          <p className="subTitleMobile">
            <strong>دانلود اپلیکیشن</strong>
          </p>
        </Margin>
      </Center>
      <Center>
        <div className="subTitleHR"></div>
      </Center>
      <Margin top={3}></Margin>
      <Row>
        <Col span={3}></Col>
        <Col span={18}>
          <div className="download-app">
            <div className="download-app-left-side">
              <h4
                style={{
                  fontFamily: "IRANSans",
                  color: "#ed1c24",
                  direction: "rtl",
                  textAlign: "center",
                  marginBottom: "10%",
                  fontSize: ".95em",
                }}
              >
                <strong>دانلود اپلیکیشن‌های ایرانیان پوشش</strong>
              </h4>

              <p className="app-textParagraphMobile">
                به منظور استفاده از خدمات جامع شرکت ایرانیان پوشش در حوزه‌های
                اعلام خسارت  می‌توانید اپلیکیشن سپر را
                دانلود نمایید.
              </p>
              <Margin top={1}>
                <a
                  href="/download-app-sanaap"
                  class="introBtn introBtn-white introBtn-animated"
                  style={{ fontSize: ".8em", fontFamily: "IRANSans" }}
                >
                  <DownloadOutlined style={{ color: "#fff" }} /> دانلود اپلیکیشن
                  سپر
                </a>
              </Margin>
              <Margin top={4}>
                <p className="app-textParagraphMobile">
                  جهت دانلود اپ‌های کارشناس شرکت ایرانیان پوشش از طریق لینک زیر
                  اقدام نمایید.
                </p>
              </Margin>
              <Margin top={1}>
                <a
                  href="/download-app-arzyab"
                  class="introBtn introBtn-white introBtn-animated"
                  style={{ fontSize: ".8em", fontFamily: "IRANSans" }}
                >
                  <DownloadOutlined style={{ color: "#fff" }} /> دانلود اپلیکیشن
                  کارشناس اتومبیل
                </a>
              </Margin>
              <Margin top={3}>
                <a
                  href="/download-app-arzyab-amval"
                  class="introBtn introBtn-white introBtn-animated"
                  style={{ fontSize: ".8em", fontFamily: "IRANSans" }}
                >
                  <DownloadOutlined style={{ color: "#fff" }} /> دانلود اپلیکیشن
                  کارشناس اموال
                </a>
              </Margin>
            </div>

            <div className="download-app-right-side">
              <img className="app-mockup" src={appMockup} />
            </div>
          </div>
        </Col>
        <Col span={3}></Col>
      </Row>
    </div>
  );
};

export default DownloadApps;
